<template>
  <div class="org-page">
    <page-title>{{ $t('orgs.subdivision_info') }}</page-title>
    <org-page :org="org" v-if="org"></org-page>
  </div>
</template>
<script>
import OrgPage from '@/components/Orgs/OrgPage/Org.vue'
export default {
  props: ['id'],
  components: {
    OrgPage
  },
  computed: {
    org () {
      return this.$store.state.orgs.orgs[this.id]
    }
  },
  methods: {
    async loadOrg () {
      this.$store.dispatch('orgs/loadOrg', this.id)
    }
  },
  async mounted () {
    this.loadOrg()
    this.$bus.$on('pathChanged', this.loadOrg)
  },
  beforeDestroy () {
    this.$bus.$off('pathChanged', this.loadOrg)
  }
}
</script>

